import BaseFilter from "../core/BaseFilter";

export default class CustomizedContactFormFilter extends BaseFilter {
    init() {
        this.customizedFormHeader = document.querySelector(".js-customized-form-header");
        this.customizedSelectTopic = document.querySelector(".js-topic-select");

        this.customizedFormHiddenField = document.querySelector('.js-customized-form-hidden-field');

        this.contactInformationWrapper = document.querySelector(".js-contact-information-wrapper");

        if (this.customizedSelectTopic) {
            this.events();
        }
    }

    events() {
        if (this.customizedSelectTopic) {
            this.customizedSelectTopic.addEventListener("change", (event) => {
                event.preventDefault();

                let options = event.target.options;

                if (options.length > 0) {
                    for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                            // console.log(options[i].dataset.postType);
                            this.customizedFormHiddenField.value = options[i].dataset.postType;
                            this.ajaxFilter(options[i].value, options[i].getAttribute("data-post-type"));
                        }
                    }
                }
            });
        }
    }

    ajaxFilter(value = "", postType = "") {
        let url = this.getApiUrlFromElement(".js-customized-form-header");

        let params = "?post-type=" + postType + "&contact-topic=" + value;

        // console.log(params);

        this.loadAjax(url, params);
    }

    afterFilterAjax(response) {
        let data = JSON.parse(response);

        if (data.header) {
            this.customizedFormHeader.innerHTML = data.header;
        }

        if (data.contact) {
            this.contactInformationWrapper.innerHTML = data.contact;
        }

        if (data.url) {
            let stateData = {
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        this.enableFilter();
    }
}
